import React, { useState } from "react";
import { Card } from '@mui/material'
import { texts } from "../../general/texts";
import colors from "../../colors";
import { ReactComponent as FriendsIcon } from "../../../icons/Friends.svg";
import { ReactComponent as WalletIcon } from "../../../icons/Wallet.svg";
import { ReactComponent as RedeemIcon } from "../../../icons/Redeem.svg";
import { ReactComponent as MobilePaymentIcon } from "../../../icons/Mobile Payment.svg";
import { ReactComponent as FriendGroupIcon } from "../../../icons/FriendGroup.svg";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CopyToClipboard from 'react-copy-to-clipboard';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from "../../../features/generalRequest";
import { selectGlobalDataState } from "../../../features/global/globalDataSlice";
import { selectUserInfo } from "../../../features/userInfo/userInfoSlice";
import CannotUseService from "./CannotUseService";
import ShareCode from "./ShareCode";
import FinishRegistration from "../../registration/registrationSteps/FinishRegistration";

const InviteFriend = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const [copied, setCopied] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const userInfo = useSelector(selectUserInfo)
    const [code, setCode] = useState('');
    const [isOpen, setIsOpen] = useState('');
    const [isShareOpen, setIsShareOpen] = useState(false);
    const [isUpgradeOpen, setIsUpgradeOpen] = useState(false);


    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const handleClose = () => {
        setIsOpen(false)
        setIsShareOpen(false)
    }

    const generateCode = () => {
        if (userInfo.canUserGenerateCode) {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: 'services', endpoint: 'InviteFriend/GenerateCode' })).then(response => {
                if (response.payload.response.success) {
                    setCode(response.payload.response.inviteFriendCode)
                }
            })
        }
        else {
            if(userInfo.accountType == 1)
            setIsOpen(true)
            else if(userInfo.accountType == 3)
            setIsUpgradeOpen(true)
        }
    }

    const useStyles = makeStyles({
        container: {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            marginTop: '80px'
        },

        inviteFriendCard: {
            padding: "15px",
            width: isSmallScreen ? "90vw" : "530px",
            height: "610px",
            borderRadius: "14px",
            textAlign: "left",

            '& h1': {
                marginBottom: "30px",
            },
            '& h3': {
                marginBottom: "10px",
            },
            '& h4': {
                margin: "0",
            },
            '& p': {
                margin: "0",
                marginBottom: "10px",
            }
        },

        flexRow: {
            display: 'flex',
            flexDirection: 'row',
        },

        flexCol: {
            display: 'flex',
            flexDirection: 'column',
        },

        easyPayButton: {
            color: colors.white,
            background: "linear-gradient(321.73deg, #F0A13D 26.7%, #EF7A30 98.66%)",
            border: 'none',
            borderRadius: '10px',
            width: '250px',
            height: '50px',
            fontSize: '18px',
            marginTop: '50px',
            cursor: 'pointer'
        },

        iconContainter: {
            width: isSmallScreen ? '95vw' : '430px',
            height: '370px',
            borderRadius: '13px',
            background: "linear-gradient(179.93deg, #FFFFFF 16.61%, #E9F7E2 102.41%)",
            alignContent: 'center',
            border: '1px solid #FFC18A',
            marginTop: isSmallScreen ? '20px' : 0
        },

        codeContainer: {
            width: '395px',
            height: '58px',
            background: colors.white,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            border: '1px solid #FFC18A',
            borderRadius: '10px',
            padding: '10px',
            marginTop: '15px',
            marginBottom: '15px'
        },

        generateButton: {
            width: '200px',
            height: '58px',
            borderRadius: '10px',
            background: '#F0FBEB',
            color: '#7A9C68',
            fontSize: '18px',
            fontWeight: 400,
            border: 'none',
            marginRight: '10px',
            cursor: 'pointer'
        },

        shareButton: {
            width: '200px',
            height: '58px',
            borderRadius: '10px',
            background: '#EBF2FA',
            color: '#577393',
            fontSize: '18px',
            fontWeight: 400,
            border: 'none',
            cursor: code === '' ? '' : 'pointer'
        }
    });
    const classes = useStyles();

    return (
        <>
            <div className={classes.container}>
                <Card className={classes.inviteFriendCard}>
                    <h1 style={{ color: colors.orange }}>{texts['title-gain-500L']}</h1>
                    <h3 style={{ color: colors.orange }}>{texts['invite-friend-steps']}</h3>
                    <div className={classes.flexRow}>
                        <RedeemIcon style={{ marginRight: 6, marginTop: 2 }} />
                        <div className={classes.flexCol}>
                            <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-step1']}</h4>
                            <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-substep1']}</p>
                        </div>
                    </div>
                    <div className={classes.flexRow}>
                        <MobilePaymentIcon style={{ marginRight: 6, marginTop: 2 }} />
                        <div className={classes.flexCol}>
                            <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-step2']}</h4>
                            <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-substep2']}</p>
                        </div>
                    </div>
                    <div className={classes.flexRow}>
                        <WalletIcon style={{ marginRight: 6, marginTop: 2 }} />
                        <div className={classes.flexCol}>
                            <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-step3']}</h4>
                            <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-substep3']}</p>
                        </div>
                    </div>
                    <h3 style={{ color: colors.orange }}>{texts['title-you-gain']}</h3>
                    <div className={classes.flexRow}>
                        <FriendsIcon style={{ marginRight: 6, marginTop: 2, width: 40, height: 40 }} />
                        <div className={classes.flexCol}>
                            <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['win-500']}</h4>
                            <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['getting-paid']}</p>
                        </div>
                    </div>
                    <button onClick={() => navigate('/inviteFriend/references')} className={classes.easyPayButton}>{texts['button-see-references']}</button>
                </Card>
                <div className={classes.flexCol} style={{ marginLeft: isSmallScreen ? 0 : '200px', alignItems: 'center' }}>
                    <div className={classes.iconContainter}>
                        <FriendGroupIcon width={300} height={250} />
                    </div>
                    <div className={classes.codeContainer}>
                        <span style={{ fontSize: '30px', color: colors.orange, fontWeight: 700 }}>{code}</span>
                        {code !== '' && (
                            <CopyToClipboard text={code} onCopy={handleCopy}>
                                {copied ? (
                                    <CheckIcon color="warning" style={{ width: 28, height: 28, marginTop: 5, cursor: 'pointer' }} />) :
                                    (<FileCopyIcon color="warning" style={{ width: 28, height: 28, marginTop: 5, cursor: 'pointer' }} />)}
                            </CopyToClipboard>
                        )}
                    </div>
                    <div className={classes.flexRow}>
                        <button onClick={generateCode} className={classes.generateButton}>{texts['button-generate']}</button>
                        <button disabled={code === ''} onClick={() => setIsShareOpen(true)} className={classes.shareButton}>{texts['button-share']}</button>
                    </div>
                </div>
            </div>
            <CannotUseService isDialogOpened={isOpen} handleClose={handleClose} />
            <ShareCode isShareOpen={isShareOpen} code={code} handleClose={handleClose} />
            <FinishRegistration isDialogOpened={isUpgradeOpen} handleCloseDialog={() => setIsUpgradeOpen(false)} />
        </>
    )
}

export default InviteFriend;